import React, { Component } from 'react';

class EmptyScreen extends Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div style={{fontSize: "16px",
                fontWeight: "bold",
                marginTop: "30px",
                textAlign: "center"}}>
                No {this.props.item} Found
            </div>
        )
    }
}

export default EmptyScreen;